import { v } from 'h3-valibot';
import {
  type FeatureToggles,
  featureTogglesSchema
} from '~~/lib/ContentfulGraphqlService/validation/featureTogglesSchema';
import type { MinifiedGlobalPageSettings } from '~~/lib/ContentfulGraphqlService';

export default function buildFeatureToggles(
  globalPageSettings: MinifiedGlobalPageSettings | null
): FeatureToggles {
  if (!globalPageSettings) {
    return {} as FeatureToggles;
  }

  const result = v.safeParse(
    featureTogglesSchema,
    globalPageSettings?.featureToggles ?? {}
  );

  // in case of result.success === false => result.output will have defaults where scheme was "broken"
  if (result.success || typeof result.output === 'object') {
    return result.output as FeatureToggles;
  }

  return {} as FeatureToggles;
}
